
import ChangePassword from "@/components/modal/ChangePassword.vue";
import DeleteAccount from "@/components/modal/DeleteAccount.vue";
import MiniTopBar from "@/components/topBar/MiniTopBar.vue";
import TopBar from "@/components/topBar/TopBar.vue";
import Error from "@/components/modal/Error.vue";
import { dateFormat } from "@/types/dateFormat";
import { Athlete } from "@/types/interface";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    TopBar,
    MiniTopBar,
    DeleteAccount,
    ChangePassword,
    Error,
  },
  data() {
    return {
      title: "Mon compte",
      showChangePasswordModal: false,
      showDeleteAccountModal: false,
      me: {} as Athlete,
      showErrorModal: false,
      updateSuccess: false,
      duplicatePseudo: false,
      username: "",
    };
  },

  methods: {
    getMe() {
      this.me = this.$store.getters["user/getMe"];
      this.me = {
        ...this.me,
        dateOfBirth: this.htmlImputDateTime(this.me.dateOfBirth),
      };
      this.username = this.me.user.username;
    },
    dateIsCorrect() {
      const date = new Date(this.me.dateOfBirth);
      if (this.me.dateOfBirth === "") return true;
      if (isNaN(date.getTime())) return false;
      if (date < new Date()) return true;
      else return false;
    },
    async updateUserInfo() {
      this.me.user.username = this.username;
      const responseUpdate = await axios.put("/athletes/" + this.me.id, {
        ...this.me,
        dateOfBirth: new Date(this.me.dateOfBirth),
      });
      if (
        responseUpdate.status === 409 &&
        responseUpdate.data.message === "USERNAME_ALREADY_EXISTS"
      ) {
        this.duplicatePseudo = true;
        return;
      }
      if (responseUpdate.status >= 300) {
        this.toggleErrorModal();
        return;
      }
      this.updateSuccess = true;
      this.$store.dispatch("user/setMe");
    },
    htmlImputDateTime(date: string) {
      const formatedDate = this.formateDate(date);
      const day = formatedDate.slice(0, 2);
      const month = formatedDate.slice(3, 5);
      const year = formatedDate.slice(6, 10);
      return `${year}-${month}-${day}`;
    },
    formateDate(date: string) {
      return new Date(date).toLocaleDateString("FR-fr", dateFormat);
    },
    goBackToDashboard() {
      console.log("Go back to Dashboard");
      this.$router.push({ name: "Home" });
    },
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal;
    },
    toggleChangePasswordModal() {
      this.showChangePasswordModal = !this.showChangePasswordModal;
    },
    toggleDeleteAccountModal() {
      this.showDeleteAccountModal = !this.showDeleteAccountModal;
    },
  },
  watch: {
    username(oldName, newName) {
      this.duplicatePseudo = false;
    },
  },
  beforeMount() {
    this.getMe();
  },
});
